import { render, staticRenderFns } from "./AcademyYoutube.vue?vue&type=template&id=db31b9d8&scoped=true&"
import script from "./AcademyYoutube.vue?vue&type=script&lang=js&"
export * from "./AcademyYoutube.vue?vue&type=script&lang=js&"
import style0 from "./AcademyYoutube.vue?vue&type=style&index=0&id=db31b9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db31b9d8",
  null
  
)

export default component.exports